<template lang="pug" src="./custom-announcement.pug"></template>

<script>
export default {
  props: ['props'],
  data: () => {
    return {
      isShowing: true
    }
  },
  methods: {
    closeModal () {
      this.isShowing = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-announcement.vue?6738278c